// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"aa497d74","374":"17af22e5"}[chunkId] + ".chunk.js";
};